module.exports = __webpack_public_path__ + "/images/ico-search.b837fa9.svg";